import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router/index'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
        return savedPosition;
      } else {
      return { x: 0, y: 0 }
    }
  }
});

function nextFactory(context, middleware, index) {
  const subsecuent = middleware[index];

  if (!subsecuent)
    return context.next;

  return (...parameters) => {
    context.next(...parameters);

    const nextMiddleware = nextFactory(context, middleware, index+1);
    subsecuent({...context, next: nextMiddleware});
  }
}

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  if(nearestWithTitle)
    document.title = nearestWithTitle.meta.title + ' - ' + process.env.VUE_APP_TITLE;

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

    const context = {from, next, router, to};

    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({...context, next: nextMiddleware});
  }

  next();
});

export default router;